import React from 'react';
import { Shield, Users, Percent } from 'lucide-react';

/**
 * Компонент налоговых льгот для расчета налога
 */
const TaxPrivilegesSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  privilegeTypes
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-5 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-purple-500" />
        Налоговые льготы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Наличие льгот */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasPrivileges"
              checked={formData.hasPrivileges}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Имеются налоговые льготы
            </span>
          </label>
        </div>

        {/* Тип льготы */}
        {formData.hasPrivileges && (
          <div className="col-span-full">
            <label htmlFor="privilegeType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Категория налоговой льготы
            </label>
            <select
              id="privilegeType"
              name="privilegeType"
              value={formData.privilegeType}
              onChange={handleInputChange}
              className={`form-select w-full ${errors.privilegeType ? 'input-error' : ''}`}
            >
              {privilegeTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name} {type.discountPercent > 0 ? `(скидка ${type.discountPercent}%)` : ''}
                </option>
              ))}
            </select>
            {errors.privilegeType && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.privilegeType}
              </p>
            )}
          </div>
        )}

        {/* Наличие доли детей */}
        <div className="col-span-full mt-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasChildrenShare"
              checked={formData.hasChildrenShare}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Users className="inline-block w-4 h-4 mr-1 text-purple-500" />
              Имущество оформлено в долях на несовершеннолетних детей
            </span>
          </label>
        </div>

        {/* Доля детей */}
        {formData.hasChildrenShare && (
          <div className="col-span-full md:col-span-1">
            <label htmlFor="childrenSharePercent" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Percent className="w-4 h-4 mr-2 text-purple-500" />
              Доля детей (%)
            </label>
            <input
              type="text"
              id="childrenSharePercent"
              name="childrenSharePercent"
              value={formData.childrenSharePercent}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.childrenSharePercent ? 'input-error' : ''}`}
              placeholder="Введите долю детей в процентах"
            />
            {errors.childrenSharePercent && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.childrenSharePercent}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Информационный блок о льготах */}
      <div className="mt-4 p-3 bg-purple-100 dark:bg-purple-900/40 rounded-lg text-sm text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800">
        <p className="font-medium">Информация о налоговых льготах:</p>
        <ul className="list-disc list-inside mt-1 space-y-1">
          <li>Ветераны боевых действий, инвалиды I и II групп, пенсионеры полностью освобождаются от налога на имущество</li>
          <li>Многодетные семьи имеют скидку 50% на налог на имущество</li>
          <li>Налоговые льготы применяются к одному объекту каждого вида имущества</li>
          <li>Доли несовершеннолетних детей также могут давать право на дополнительные льготы</li>
        </ul>
      </div>
    </div>
  );
};

export default TaxPrivilegesSection;